"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadResources = void 0;
var react_i18next_1 = require("react-i18next");
var localStorage_1 = __importDefault(require("../config/localStorage"));
var service_1 = require("./service");
var i18next_1 = __importDefault(require("i18next"));
var i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
var loadResources = function () { return __awaiter(void 0, void 0, void 0, function () {
    var storeLang, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, localStorage_1.default.getItem('language')];
            case 1:
                storeLang = _a.sent();
                return [4 /*yield*/, service_1.TranslaitonService.getTranslation(storeLang !== null && storeLang !== void 0 ? storeLang : 'en')];
            case 2:
                data = _a.sent();
                return [2 /*return*/, data];
        }
    });
}); };
exports.loadResources = loadResources;
var lang = navigator.language;
if (lang === 'en-US') {
    lang = 'en';
}
var backendOptions = {
    request: function (_options, _url, _payload, callback) {
        try {
            (0, exports.loadResources)().then(function (response) {
                callback(null, {
                    data: response,
                    status: 200,
                });
            });
        }
        catch (err) {
            callback(null, {
                status: 500,
            });
        }
    },
    allowMultiLoading: true,
};
i18next_1.default
    .use(i18next_http_backend_1.default)
    .use(react_i18next_1.initReactI18next)
    .init({
    backend: backendOptions,
    fallbackLng: '{{lng}}',
    load: 'currentOnly',
    keySeparator: false,
    ns: ['translations'],
    defaultNS: 'translations',
    saveMissing: true,
    interpolation: {
        escapeValue: false,
    },
});
exports.default = i18next_1.default;
// export const I18nLanguageContext = React.createContext({
// 	newI18n: i18n,
// 	languages: {},
// 	updateI18n: () => {},
// });
// export const I18nLanguageProvider = ({ children }: any) => {
// 	const [languages, setLanguages] = useState();
// 	const [callLanguageTranslation, responseLanguageTranslation] = useLazyQuery(
// 		GET_LANGUAGE_WITH_TRANSLATION,
// 	);
// 	console.log({ responseLanguageTranslation });
// 	useEffect(() => {
// 		assembleLanguage();
// 	}, []);
// 	useEffect(() => {
// 		if (responseLanguageTranslation?.data?.getLanguageWithTranslation) {
// 			translateResources(
// 				responseLanguageTranslation?.data?.getLanguageWithTranslation,
// 			);
// 		}
// 	}, [responseLanguageTranslation]);
// 	const translateResources = (getData: any) => {
// 		const langArray: any = {};
// 		if (getData && getData.length > 0) {
// 			getData.map((item: any) => {
// 				const temp = {
// 					label: item.label,
// 					value: item.code,
// 					translation: JSON.parse(item.translation),
// 				};
// 				langArray[temp.value] = temp;
// 			});
// 		}
// 		setLanguages(langArray);
// 		if (!isEmpty(langArray)) {
// 			i18n.use(initReactI18next).init(
// 				{
// 					compatibilityJSON: 'v3',
// 					resources: langArray,
// 					fallbackLng: 'en',
// 					lng: 'en',
// 					keySeparator: false,
// 					interpolation: {
// 						escapeValue: false,
// 					},
// 				},
// 				(err) => {
// 					if (err) {
// 						return console.log('something went wrong:', err);
// 					}
// 				},
// 			);
// 		}
// 	};
// 	const assembleLanguage = async () => {
// 		const selectedCountry = await localDb.getItem('country');
// 		callLanguageTranslation({
// 			variables: { country_code: selectedCountry || 'BI' },
// 		});
// 	};
// 	return (
// 		<I18nLanguageContext.Provider
// 			value={{
// 				newI18n: i18n,
// 				languages: languages != undefined && languages,
// 				updateI18n: assembleLanguage,
// 			}}
// 		>
// 			{children}
// 		</I18nLanguageContext.Provider>
// 	);
// };
